// @module C3.ShoppingExtensions.PLP
define('C3.ShoppingExtensions.SignUp.CustomFields.View'
,	[
	'c3_shoppingextensions_signup_customfields.tpl'
	
	//,	'C3.ShoppingExtensions.PLP.SS2Model'
	
	,	'Backbone'
    ]
, function (
	c3_shoppingextensions_signup_customfields_tpl
	
	//,	PLPSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class C3.ShoppingExtensions.PLP.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_signup_customfields_tpl

	,	initialize: function (options) {

			 var self = this;

			 this.options = options;

			 //console.log(this.options)

		      this.options.LoginRegisterPage.on('beforeRegister', function (formFields)
		      {
		        // Unchecked checkboxes are not included in the data object, so we need to check they exist
		        if (!formFields.custentity13)
		        {
		            // All views have the ability to render error messages via ErrorManagement.js.
		            // By default, they will automatically find the nearest alert-placeholder, so our template needs one.
		            self.showError(_.translate('You must accept the terms and conditions to register an account'))
		            return jQuery.Deferred().reject()
		        }
		      });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return C3.ShoppingExtensions.PLP.View.Context
	,	getContext: function getContext()
		{
			//@class C3.ShoppingExtensions.PLP.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
